import axios from "axios";
import { ElMessage } from "element-plus";
import store from "@/store";
import { installDedup } from "./dedup";

const isTest = process.env.VUE_APP_MODAL_LOGIN || false;
const isDev = process.env.NODE_ENV === "development";

const apiV2 = axios.create({
  baseURL: isDev
    ? "/api/v2"
    : isTest
      ? "https://staging.marsit.uz/api/v2"
      : "https://api.marsit.uz/api/v2",
  headers: {
    "Content-Type": "application/json",
    "X-App-Audience": "admin",
  },
  withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

function processQueue(error) {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve();
    }
  });
  failedQueue = [];
}

function forceLogout() {
  const baseV1 = isDev
    ? "/api/v1"
    : isTest
      ? "https://staging.marsit.uz/api/v1"
      : "https://api.marsit.uz/api/v1";
  axios
    .post(`${baseV1}/auth/signout?audience=admin`, {}, { withCredentials: true })
    .catch(() => {});
  store.commit("auths/logout");
  window.location.href = "/";
}

apiV2.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // Rate limited
    if (status === 429) {
      forceLogout();
      return Promise.reject(error);
    }

    // 401 or 403 = token expired — try refresh
    if ((status === 401 || status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => apiV2(originalRequest));
      }

      isRefreshing = true;

      try {
        const baseV1 = isDev
          ? "https://staging.marsit.uz/api/v1"
          : isTest
            ? "https://staging.marsit.uz/api/v1"
            : "https://api.marsit.uz/api/v1";

        await axios.get(`${baseV1}/auth/token?audience=admin`, {
          withCredentials: true,
        });

        processQueue(null);
        return apiV2(originalRequest);
      } catch {
        processQueue(new Error("Refresh failed"));
        forceLogout();
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }

    if (error?.response?.status?.toString().startsWith("5")) {
      ElMessage.error("Backend error");
    }

    return Promise.reject(error);
  }
);

installDedup(apiV2);

export default apiV2;
